/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { ComponentClassNames, mergeStyleSets } from "@microsoft/shifts-ui-core";

type TypeMemberRequestStyles = "stack";
/**
 * Gets the 'MemberRequest' component CSS class names.
 * @returns The 'MemberRequest' component CSS class names.
 */
export const getClassNames = (): ComponentClassNames<TypeMemberRequestStyles> => {
    return mergeStyleSets({
        stack: {
            padding: "0.2rem 0"
        }
    });
};
